<template>
  <div :class="$style.intro">
    <img :src="data.logo" :alt="data.title" />
    <h2>
      <em>{{ data.title }}</em>
      <span>游戏简介</span>
    </h2>
    <p>{{ data.text }}</p>
    <a v-if="data.url" :href="data.url" target="_blank">
      <span><i>点击</i>查看游戏 &rarr;</span>
      <span><i>点击</i>查看游戏 &rarr;</span>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
  },
}
</script>

<style lang="less" module>
.intro {
  img {
    @img-height: 1.05rem;

    width: auto;
    height: @img-height;
  }

  h2 {
    margin-top: 1.5em;
    font-size: 0.24rem;
    font-weight: 400;

    em {
      display: none;
    }

    @media screen and (max-width: @tablet-width) {
      font-size: 16px;
    }
  }

  p {
    margin-top: 1em;
    margin-bottom: 3em;
    line-height: 1.5;
    color: #5f6464;
  }

  a {
    @btn-width: 2.08rem;
    @btn-height: 0.5rem;

    .size(@btn-width, @btn-height);
    position: relative;
    display: inline-block;
    text-decoration: none;
    overflow: hidden;

    @media screen and (max-width: @tablet-width) {
      .size(@btn-width * 1.5, @btn-height * 1.5);
    }

    i {
      font-style: normal;
    }

    span {
      .size(100%);
      position: absolute;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      transition-property: top;

      &:nth-child(1) {
        top: 0;
        background-color: @primary;
        color: #fff;
        transition-duration: 0.3s;
      }

      &:nth-child(2) {
        top: 100%;
        background-color: #e2c692;
        color: #000;
        transition-duration: 0.5s;
      }
    }

    &:hover {
      span {
        &:nth-child(1) {
          top: -100%;
          transition-duration: 0.5s;
        }

        &:nth-child(2) {
          top: 0;
          transition-duration: 0.3s;
        }
      }
    }
  }
}
</style>
